/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Field from 'components/shared/fields/field/field';
import Button from 'components/shared/button/button';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/fields/input/input_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ FIELD : INPUT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class InputField extends Component {
    constructor(props) {
        super(props);
        this.state = {isValid: null, currentValue: '', dataSubmitted: false};
    }

    setFieldState = (value) => this.setState({
        isValid: this.handleValidation(value) ? true : null,
        currentValue: value
    });
    handleValidation = (value) => this.props.validation === null ? /^[a-z\d\-_\s]+$/i.test(value) : new RegExp(this.props.validation).test(value);
    submitData = () => {
        if (this.handleValidation(this.state.currentValue) && !this.state.dataSubmitted) {
            this.setState({dataSubmitted: true });
            this.props.processSubmit(this.state.currentValue);
        } else {
            this.setState({isValid: false})
        }
    };
    handleChange = (e) => {
        let val = e.target.value;
        if (this.props.placeholder === 'YYYY-MM-DD') {
            let test;
            if (val > this.state.currentValue) {
                test = val.slice(-1);
                if (!/^[0-9]$/.test(test) || val.length > 10) {
                    val = val.slice(0, -1)
                }
                if(val.length === 4 || val.length === 7) val = `${val}-`;
            } else if (val.length === 4 || val.length === 7) {
                val = `${val.slice(0, -1)}`
            }
            if(val.length === 4 || val.length === 7) val = `${val}-`;
        }
        this.setFieldState(val);
    };
    handleKey = (e) => {
        if (e.key === 'Enter') this.submitData();
    };
    handleButtonClick = () => this.submitData();

    render() {
        return (
            <Field hasButton={this.props.hasButton} isValid={this.state.isValid}>
                <input id={this.props.id} className={`${sheet.classes.input} input isValid-${this.state.isValid}`}
                       placeholder={this.props.placeholder} onKeyUp={this.handleKey} value={this.state.currentValue}
                       onInput={this.handleChange}
                       disabled={this.state.dataSubmitted}/>
                {this.props.hasButton ?
                    <Button klass={`button enter${this.state.dataSubmitted ? ' disabled' : ''}`} onClick={this.handleButtonClick}>Enter</Button> : null}
            </Field>
        );
    }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default InputField;
